import createRouter from 'router5';
import loggerPlugin from 'router5/plugins/logger';
import browserPlugin from 'router5/plugins/browser';

const routes = [
  // default
  {
    name: 'authenticate',
    path: '/',
  },

  // unauthorized
  {
    name: 'error',
    path: '/error',
  },

  // Payment Collection
  {
    name: 'payment',
    path: '/:type/:id<\\d+>',
  },
  {name: 'collectpayment', path: '/collect'},
  {name: 'completepayment', path: '/complete'},
  {name: 'paypalcallback', path: '/complete/paypal'},
  {name: 'wepaycallback', path: '/complete/wepay'},
];

const router = createRouter(routes, {
  defaultRoute: 'authenticate',
  queryParamsMode: 'default',
})
  .usePlugin(loggerPlugin)
  .usePlugin(browserPlugin({useHash: true}));

export default router;



// WEBPACK FOOTER //
// ./src/paymentApp/paymentRouter.js